/** wa.me link with a prefilled message (§28). Returns null for an unusable number. */
export function buildWhatsAppUrl(e164: string, message: string): string | null {
  const digits = e164.replace(/\D/g, '');
  if (digits.length < 8 || digits.length > 15) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}
